export default {
  primary: "#420516",
  secondary: "#d03d56",
  black: "#000",
  white: "#fff",
  dark_primary: "#0D0104",
  blue: "#24a0ed"
};
